import _classCallCheck from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import HTMLMaskElement from './html-mask-element.js';
import IMask from '../core/holder.js';
import './mask-element.js';

/** Bridge between InputElement and {@link Masked} */
var HTMLInputMaskElement = /*#__PURE__*/function (_HTMLMaskElement) {
  _inherits(HTMLInputMaskElement, _HTMLMaskElement);
  /** InputElement to use mask on */

  function HTMLInputMaskElement(input) {
    var _this;
    _classCallCheck(this, HTMLInputMaskElement);
    _this = _callSuper(this, HTMLInputMaskElement, [input]);
    _this.input = input;
    return _this;
  }

  /** Returns InputElement selection start */
  _createClass(HTMLInputMaskElement, [{
    key: "_unsafeSelectionStart",
    get: function get() {
      return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
    }

    /** Returns InputElement selection end */
  }, {
    key: "_unsafeSelectionEnd",
    get: function get() {
      return this.input.selectionEnd;
    }

    /** Sets InputElement selection */
  }, {
    key: "_unsafeSelect",
    value: function _unsafeSelect(start, end) {
      this.input.setSelectionRange(start, end);
    }
  }, {
    key: "value",
    get: function get() {
      return this.input.value;
    },
    set: function set(value) {
      this.input.value = value;
    }
  }]);
  return HTMLInputMaskElement;
}(HTMLMaskElement);
IMask.HTMLMaskElement = HTMLMaskElement;
export { HTMLInputMaskElement as default };